export default __webpack_public_path__ + "static/media/tempestofset_icon.3d1021cf.png";